module.exports = __webpack_public_path__ + "img/model_300.961eaca8.png";